// Single source of truth for Byt3con September 2026 event dates.
// EDIT THESE VALUES TO CHANGE DATES SITE-WIDE.

export const EVENT_START = new Date('2026-09-17T09:00:00+05:30'); // Thu
export const EVENT_END = new Date('2026-09-19T18:00:00+05:30'); // Sat

export const EARLY_BIRD_DEADLINE = new Date('2026-08-15T23:59:59+05:30');

export const EVENT_DATE_LABEL = '17–19 September 2026';
export const EVENT_DAY_LABEL = 'Thu – Sat';
export const EARLY_BIRD_PERIOD_LABEL = 'Ends 15 Aug 2026';
export const LATE_PERIOD_LABEL = '16 Aug – 19 Sept 2026';
